
import { ApplicationApi } from './api'

export default class ApplicationService {
    
  constructor() {
    this.applicationApi = new ApplicationApi()
  }

  putBoardReport(params) {
    return this.applicationApi.putBoardReport(params)
  }
  delFolder(params) {
    return this.applicationApi.delFolder(params)
  }
  gDriveInput(params) {
    return this.applicationApi.gDriveInput(params)
  }

  exportFile(params) {
    return this.applicationApi.exportFile(params)
  }

  getDataSource() {
    return this.applicationApi.getDataSource()
  }

  checkFolder(params) {
    return this.applicationApi.checkFolder(params)
  }
  UpdateDataSource(params) {
    return this.applicationApi.UpdateDataSource(params)
  }

  originUpload(params) {
    return this.applicationApi.originUpload(params)
  }

  devUpload(params) {
    return this.applicationApi.devUpload(params)
  }

  tortueUpload(params) {
    return this.applicationApi.tortueUpload(params)
  }

  getColumns(params) {
    return this.applicationApi.getColumns(params)
  }
  
  updateColumns(params) {
    return this.applicationApi.updateColumns(params)
  }  

  editColumns(params) {
    return this.applicationApi.editColumns(params)
  }
  
  delColumns(params) {
    return this.applicationApi.delColumns(params)
  }    

  getTables(params) {
    return this.applicationApi.getTables(params)
  }
  
  updateTables(params) {
    return this.applicationApi.updateTables(params)
  }  

  editTables(params) {
    return this.applicationApi.editTables(params)
  }

  delTables(params) {
    return this.applicationApi.delTables(params)
  }
  
  createSource(params) {
    return this.applicationApi.createSource(params)
  } 
  
  setColumnScope(params) {
    return this.applicationApi.setColumnScope(params)
  }
}